import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppRoutes } from '@/app/router'
import { useIdentityRefresh } from '@/hooks/use-auth'
import { setUnauthorizedHandler } from '@/lib/api'

/** Refresh de başarısız olduğunda (401) girişe yönlendirir; bkz. `lib/api.ts`. */
function UnauthorizedRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    setUnauthorizedHandler(() => navigate('/giris', { replace: true }))
  }, [navigate])

  return null
}

function IdentityRefresh() {
  useIdentityRefresh()
  return null
}

export function App() {
  return (
    <>
      <UnauthorizedRedirect />
      <IdentityRefresh />
      <AppRoutes />
    </>
  )
}
